import { combineReducers } from 'redux';

import atendimentos from './atendimentos/combineReducers';
import processosAdministrativos from './processosAdministrativos/combineReducers';

export default combineReducers({ atendimentos, processosAdministrativos });
